import {
  RadioGroupItem as RadioGroupItemPrimitive,
  type RadioGroupItemProps as RadioGroupItemPrimitiveProps,
} from "@radix-ui/react-radio-group";

import React from "react";

import { BodyText } from "@/components/ui/Text";
import { cn } from "@/lib/utils";

import { RadioGroupIndicator } from "./RadioGroupIndicator";

interface RadioGroupItemProps {
  label: string | React.ReactNode;
}

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupItemPrimitive>,
  React.ComponentPropsWithRef<typeof RadioGroupItemPrimitive> &
    RadioGroupItemPrimitiveProps &
    RadioGroupItemProps
>(({ id, label, value, disabled }, ref) => (
  <div className="flex items-center">
    <RadioGroupItemPrimitive
      className={cn(
        "w-4 h-4 rounded-full border border-solid border-secondary",
        disabled ? "bg-neutral-300" : "bg-white",
      )}
      value={value}
      id={id}
      ref={ref}
      disabled={disabled}
    >
      <RadioGroupIndicator disabled={disabled} />
    </RadioGroupItemPrimitive>
    <label
      className={cn("text-xs ml-1", {
        "text-neutral-600": disabled,
        "text-black": !disabled,
      })}
      htmlFor={id}
    >
      {typeof label === "string" ? (
        <BodyText size="sm">{label}</BodyText>
      ) : (
        label
      )}
    </label>
  </div>
));

RadioGroupItem.displayName = RadioGroupItemPrimitive.displayName;

export { RadioGroupItem };
